export default __webpack_public_path__ + "static/media/iPhone 8 - 5.056df35e.png";